export default "__VITE_ASSET__Dw83Umzh__"